import styled from "styled-components";

export const ExerciseTodayBox = styled.div`
  gap: 14px;
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
`;

export const ExerciseTodayTit = styled.h3<{ $isHealthEnterInfo?: boolean }>`
  gap: 12px;
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  font-size: 2rem;
  font-weight: 700;
  flex-direction: column;

  margin: ${({ $isHealthEnterInfo }) =>
    $isHealthEnterInfo ? "13px 0 0 0" : "0 0 0 0"};

  span {
    color: ${(props) => props.theme.colors.text3};
    font-size: 1.3rem;
    font-weight: 300;
    line-height: 150%;
  }
`;

export const ExerciseTodayExplain = styled.div`
  color: ${(props) => props.theme.colors.black50};
  font-size: 1.1rem;
  font-weight: 400;
`;

export const ExerciseToday = styled.div`
  left: -16px;
  width: 100vw;
  height: 290px;
  position: relative;
  background: ${(props) => props.theme.colors.primary12};
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 40%,
    #000 60%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 40%,
    #000 60%,
    transparent 100%
  );

  img {
    width: 100vw;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const AlertText = styled.div`
  display: flex;
  height: 240px;
  color: ${(props) => props.theme.colors.text3};
  font-size: 1.4rem;
  line-height: 150%;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

export const ExerciseTodayInfo = styled.div`
  position: absolute;
  bottom: 0;
`;
